<template>
 <div>
  <div id="rbcenterParent">
    <div>
      <img v-if="$store.state.openRebateUI1" id="avatarIcon" src="~assets/img/rebateUI1/avatar-icon.png"/>
      <img v-else id="avatarIcon" src="~assets/img/rebate-center/avatar-icon.png"/>
    </div>
    <div id="topRoleInfo">
      <div><label>{{$store.state.roleInfoData.roleName}}</label></div>
      <div><label>(ID:{{$store.state.commonParameters.rid}})</label></div>
      <div>
        <!-- 无需修改等级 -->
        <span v-if="$store.state.userInfoData.changelevel === '0'">
          <label>
            <span v-if="$store.state.roleInfoData.serverName == '' || $store.state.roleInfoData.serverName == undefined">
              (等级:{{$store.state.roleInfoData.level}})
            </span>
            <span v-else>
              (区服:{{$store.state.roleInfoData.serverName}} 等级:{{$store.state.userInfoData.changelevel}})
            </span>
          </label>
        </span>
        <span v-else>
          <label>
            <span v-if="$store.state.roleInfoData.serverName == '' || $store.state.roleInfoData.serverName == undefined">
              (等级:{{$store.state.userInfoData.changelevel}})
            </span>
            <span v-else>
              (区服:{{$store.state.roleInfoData.serverName}} 等级:{{$store.state.userInfoData.changelevel}})
            </span>
          </label>
        </span>
      </div>
    </div>
    <div id="wxbindparent">
      <span v-if="$store.state.userInfoData.wxuser === '0'">
        <img id="wxbindIcon" @click="showWxBind" src="~assets/img/rebate-center/wx-unbind.png"/>
      </span>
      <span v-else>
        <img id="wxbindIcon" src="~assets/img/rebate-center/wx-bind.png"/>
      </span>
    </div>
  </div>
 </div>
</template>

<script>
 export default {
   data () {
     return {

     }
   },
   components: {

   },
   methods:{
    showWxBind(){
      this.$emit("setWxBindCallback")
    }
   }
 }
</script>

<style>

  /* @import 'assets/css/rbcenter-top.css'; */
  #rbcenterParent{
    display: flex;
    flex-flow: row;
    padding-left: 5px;
    padding-top: 15px;
    align-items: center;
    height: 60px;
    /* display: inline-block; */
  }

  /* #rbcenterParent div{
    flex: 1;
  } */

  #avatarIcon{
    float: left;
    height: 57px;
    width: 57px;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
  }

  #topRoleInfo{
    height: 57px;
    display: flex;
    flex-flow: column;
    padding-left: 5px;
    /* margin-left: 15px; */
    text-align: start;
  }

  #topRoleInfo div{
    flex: 1;
  }

  #topRoleInfo label{
    /* flex: 1; */
    color: aliceblue;
    font-size: x-small;
  }
  
  #wxbindIcon{
    /* clear: left; */
    /* float: right; */
    height: 20px;
    width: 60px;
    text-align: right;
    /* 解决图片拉伸问题 */
    object-fit: scale-down;
  }
  #wxbindparent{
    flex: 1;
    text-align: end;
    padding-right: 5px;
  }

</style>


// WEBPACK FOOTER //
// src/views/RebateView/RbCenterTop.vue